import React, { Component } from 'react';
import { logger, sessionId } from '../../logging/logger';

const log = logger('ErrorBoundary');

class ErrorBoundary extends Component {

  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    log.error({
      error,
      errorInfo
    });
  }

  render() {
    if(this.state.errorInfo) {
      // error path
      return (
        <div>
          <h2>Something went wrong</h2>
          <p>If the error persists, please <a href="mailto:info@11pets.com">contact support</a> and mention the code: <code>{sessionId}</code></p>
        </div>
      );
    }
    return this.props.children;
  }
}



export default ErrorBoundary;